import { Component, AfterViewInit, OnInit, OnDestroy, NgZone, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import {
  TdLoadingService,
  TdMediaService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
  TdDataTableComponent,
} from '@covalent/core';

import { Anamnesis } from '../../../../models';

import { AnamnesisService, LoginService } from '../../../../services/';

@Component({
  selector: 'qs-anamnesis',
  templateUrl: './anamnesis.component.html',
  styleUrls: ['./anamnesis.component.scss'],
  viewProviders: [AnamnesisService],
})
export class AnamnesisComponent implements AfterViewInit, OnInit, OnDestroy {

  private idPaciente: string;
  private anamnesis: Anamnesis[];

  private _xsScreen: Subscription;

  // ITDdDataTableComponent
  // Columnas
  private columnsAll: ITdDataTableColumn[] = [
    { name: 'fecha', label: 'Fecha', tooltip: 'Fecha', sortable: true },
    { name: 'hora', label: 'Hora', tooltip: 'Hora', sortable: false },
    { name: 'texto', label: 'Anamnesis', tooltip: 'Anamnesis', sortable: false },
    { name: 'linea', label: 'Linea', sortable: false, hidden: true },
    { name: 'visita', label: 'Visita', sortable: false, hidden: true },
    { name: 'motivo', label: 'Motivo', sortable: false, hidden: true },
    { name: 'numeroExpediente', label: 'Núm. Exp.', sortable: false, hidden: true },
    { name: 'dniMedico', label: 'DNI', sortable: false, hidden: true },
    { name: 'idAnamnesis', label: 'Id Anamnesis', hidden: true },
    { name: 'dniBorrado', label: 'DNI Borrado', sortable: false, hidden: true },
    { name: 'motivoBorrado', label: 'M.B.', sortable: false, hidden: true },
    { name: 'accion', label: 'Acción', sortable: false, hidden: true },
  ];

  private columns: ITdDataTableColumn[] = this.columnsAll;
  // Datos
  private filteredData: Anamnesis[] = [];
  private filteredDataTotal: number;

  // Propiedades
  private clickable: boolean = true;
  private selectable: boolean = false;
  private sortable: boolean = true;
  private sortBy: string = 'fecha';
  private sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  private searchTerm: string = '';

   @ViewChild(TdDataTableComponent) tableComponent: TdDataTableComponent;

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _anamnesisService: AnamnesisService,
    private _loginService: LoginService,
    private _dataTableService: TdDataTableService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService, ) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.watchScreen();
    this._loadingService.register('anamnesis.load');
    this._anamnesisService.obtenerAnamnesis(this._loginService.consulta.numeroExpediente, this._loginService.consulta.visita)
    .subscribe((res: any) => {
      this.anamnesis = res.respuesta.anamnesis || '';
      this.filteredData = this.anamnesis;
      this.filteredDataTotal = this.anamnesis.length;
      this._loadingService.resolve('anamnesis.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo anamnesis.', 'OK', 6000);
      this._loadingService.resolve('anamnesis.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    this.watchScreen();
  }

  /**
   * watchScreen:
   * Observable de cambio de resolució. Oculta o muestra columnas
   * xs < 600px
   * sm > 600px
   * md < 1280px
   */
  watchScreen(): void {
    this._xsScreen = this.media.registerQuery('xs').subscribe((matches: boolean) => {
      this._ngZone.run(() => {
        if (matches) {
          // Ocultamos columnas
          this.columns[0].hidden = true;
          // this.tableComponent.refresh();
        } else {
          // Mostramos columnas
          this.columns[0].hidden = false;
          // this.tableComponent.refresh();
        }
      });
    });
  }

  openDetalleAlta(): void {
    this._router.navigate(['/main/consulta/' + this._loginService.consulta.numeroExpediente + '/hojadeseguimiento',
    { outlets: { hojadeseguimiento: ['anamnesisdetalle'] } }]);
  }

  /**
   * openDetalle: Muestra la vista de detalle pasando la linea seccionada
   * @param any: $event <- Fila seleccionada
   */
  openDetalle(anamnesis: Anamnesis): void {
    if (anamnesis) {
      this._loginService.transient = anamnesis;
      this._router.navigate(['/main/consulta/' + this._loginService.consulta.numeroExpediente + '/hojadeseguimiento',
      { outlets: { hojadeseguimiento: ['anamnesisdetalle'] } }]);
    }
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.anamnesis;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }

  ngOnDestroy(): void {
    this._xsScreen.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/hojadeseguimiento/anamnesis/anamnesis.component.ts